
import {getUrlData} from '@/helpers/appUrl.js'
const {appType} = getUrlData()
export const appInfo = {
  type: appType,
  name: "IRFA COLLEGE OF HEALTH SCIENCE AND TECHNOLOGY",
  motto: "LEARN,LAUGH and GROW.",
  vision:
    "We aim at producing lifelong learners and well enlightened global citizens processing the best of intellectual abilities coupled with the right and most pristine moral values",
  address: "Thecodeunit",
  email: "thecodeunit@gmail.com",
  phone: "27282",
};
